import { ProductionJobType } from "../enums/production-job-type";
import { IMetricGroup } from "../shared/metric-interface";

export class UnplannedMetric implements IMetricGroup {

    public jobType : ProductionJobType = ProductionJobType.NotApplicable;
        
    public quantity : number = 0;

}
